import React from "react";
import { ConveniosProvider } from "./context/convenios-context";
import { Convenios } from "./convenios";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const ConveniosFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Convênios"}>
            <ConveniosProvider>
                <Convenios />
            </ConveniosProvider>
        </BaseInternalFormFactory>
    );
};

export default ConveniosFactory;
